<div class="spinnerBackground">
    <mat-spinner class="spinner" color="accent"></mat-spinner>
</div>